import * as yup from 'yup';

export default yup.object().shape({
  category: yup
    .string()
    .required('*Category is required')
    .min(3, '*Category must be between 3-15 characters')
    .max(25, '*Category must be between 3-25 characters')
});
